import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Ativar modo claro" : "Ativar modo escuro"}
      title={isDark ? "Mudar para modo claro" : "Mudar para modo escuro"}
      onClick={toggleTheme}
      data-testid="theme-toggle-button"
      className={`relative inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full border transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 ${
        isDark ? "bg-slate-700 border-slate-600" : "bg-slate-300/80 border-white/40"
      }`}
    >
      <Sun className="pointer-events-none absolute left-1.5 h-3.5 w-3.5 text-yellow-300" />
      <Moon className="pointer-events-none absolute right-1.5 h-3.5 w-3.5 text-slate-300" />
      <span
        className={`relative z-10 flex h-5 w-5 items-center justify-center rounded-full shadow-md transition-transform duration-300 ${
          isDark ? "translate-x-[30px] bg-slate-900" : "translate-x-[3px] bg-white"
        }`}
        style={{ transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)" }}
      >
        {isDark ? (
          <Moon className="h-3 w-3 text-amber-300" />
        ) : (
          <Sun className="h-3 w-3 text-yellow-500" />
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;
